import { EventEmitter2 } from 'eventemitter2';
import { SocketService } from '@shared/socket.service';

export class JackpotRoom {
  events: EventEmitter2 = new EventEmitter2();
  private potid: number;
  constructor(private socketService: SocketService, potid: number) {
    this.potid = potid;
    this.socketService.socket.onAny((eventName, data) => {
      if (!data) {
        return;
      }

      if (data.potid !== undefined) {
        data.potid = Number(data.potid);
        if (data.potid === this.potid) {
          this.events.emit(eventName, data);
        }
      } else {
        this.events.emit(eventName, data);
      }
    });
  }
}
